import { useNavigate } from 'react-router-dom';
import axiosInstance from '../Service/axiosConfig';

export const useNavigationURLs = () => {
    const navigate = useNavigate();
    const navigateToURL = (hcc_id, type) => {
        if (localStorage.getItem('token')) {
            if (type === 'profile') {
                navigate(`/messages/${hcc_id}`);
            } else {
                window.open(`/messages/${hcc_id}`, '_blank');
            }
        } else {
            document.querySelector('.login-text').click();
        }
    };
    return { navigateToURL };
};

export const copyRequirement = async (data) => {
    try {
        const shareUrl = `${axiosInstance.getUri()}/share/ar/${data.id}/?v=1`;
        const WA_CHANNEL = "https://whatsapp.com/channel/0029VbAl7qFCRs1p0BboSv1M";

        const text = `*Apply Here* : ${data?.character ? `Required ${data.character}` : ""} ` +
            `${data.audition?.project_type ? `for ${data.audition.project_type}` : ""} ` +
            `${data?.gender ? `- (Gender: ${data.gender})` : ""} ` +
            `${data?.from_age ? `- Age(${data.from_age}-${data.to_age})yrs` : ""} ` +
            `${data?.loc_lang?.languages ? `- (Languages: ${data.loc_lang.languages})` : "- Languages: Any Language"} ` +
            `${data?.loc_lang?.state ? `- (Location: ${data.loc_lang.state})` : "- Location: Any Location"} ` +
            `${data.audition?.banner_name ? `- (Banner: ${data.audition.banner_name})` : ""} ` +
            `${shareUrl}\n*WhatsApp Channel* : ${WA_CHANNEL}`;

        await navigator.clipboard.writeText(text);
        console.log("Requirement copied to clipboard!");
    } catch (err) {
        console.error('Failed to copy text to clipboard:', err);
    }
};

export const shareRequirement = async (share_to, data) => {
    try {
        const shareUrl = `${axiosInstance.getUri()}/share/ar/${data.id}/?v=1`;
        const WA_CHANNEL = "https://whatsapp.com/channel/0029VbAl7qFCRs1p0BboSv1M";

        const requirementText = `*Apply Here* : ${data?.character ? `Required ${data.character}` : ""} ` +
            `${data.audition?.project_type ? `for ${data.audition.project_type}` : ""} ` +
            `${data?.gender ? `- (Gender: ${data.gender})` : ""} ` +
            `${data?.from_age ? `- Age(${data.from_age}-${data.to_age})yrs` : ""} ` +
            `${data?.loc_lang?.languages ? `- (Languages: ${data.loc_lang.languages})` : "- Languages: Any Language"} ` +
            `${data?.loc_lang?.state ? `- (Location: ${data.loc_lang.state})` : "- Location: Any Location"} ` +
            `${data.audition?.banner_name ? `- (Banner: ${data.audition.banner_name})` : ""} ` +
            `${shareUrl}\n*WhatsApp Channel* : ${WA_CHANNEL}`;

        const finalText = encodeURIComponent(requirementText);

        if (share_to === "whatsapp") {
            window.open(`https://api.whatsapp.com/send?text=${finalText}`, '_blank');
        } else if (share_to === "fb") {
            window.open(`https://www.facebook.com/sharer/sharer.php?u=${finalText}`, '_blank');
        } else if (navigator.share) {
            await navigator.share({
                title: 'Share Post',
                text: requirementText
            });
        }
    } catch (err) {
        console.error('Failed to share content:', err);
    }
};



